import { render, staticRenderFns } from "./BlockInputs.vue?vue&type=template&id=71d95b66&"
import script from "./BlockInputs.vue?vue&type=script&lang=ts&"
export * from "./BlockInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports